<template>
  <div>
    <div class="count_common">
      <span class="count_common_icon"></span> <span class="count_common_text">{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CountCommon',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {


    }
  }
}
</script>
 
<style lang = "less" scoped>
.count_common {
  position: relative;
  width: 100%;
  padding-bottom: .1rem;
  border-bottom: 1px solid #efe8cb;

  &_icon {
    display: inline-block;
    width: 4px;
    height: 16px;
    background: #5bbee1;
    position: absolute;
    top: 1%;
  }

  &_text {
    display: inline-block;
    font-size: .16rem;
    margin-left: .1rem;
  }
}
</style>